// extracted by mini-css-extract-plugin
export var divider = "_tl-0";
export var systemMessage = "_tl-1";